import TariffsSettings from './TariffsSettings'

export default TariffsSettings
